import { render, staticRenderFns } from "./PromotionStepDisplaying.vue?vue&type=template&id=7bf1980c&scoped=true&"
import script from "./PromotionStepDisplaying.vue?vue&type=script&lang=js&"
export * from "./PromotionStepDisplaying.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStepDisplaying.vue?vue&type=style&index=0&id=7bf1980c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf1980c",
  null
  
)

export default component.exports